
import {Options, Vue}      from "vue-class-component";
import SoundWave           from '@/components/SoundWave/SoundWave.vue';
import SoundSubTitles      from '@/components/SoundSubTitles/SoundSubTitles.vue';
import {ITestimonialAudio} from "@/models/vimy.models";
import {PropType}          from "vue";
import * as SU             from '@braintree/sanitize-url';
import {translate}         from "@/helpers/locale-helper";
import {DataStore} from "@/store";

@Options({
           components: {
             SoundWave,
             SoundSubTitles
           },
           props:      {
             options: Object as PropType<ITestimonialAudio>,
             index:   Number
           }
         })
export default class MemorialAudio extends Vue
{
  declare $refs: {
    audio: HTMLAudioElement,
    spanTitle: HTMLElement,
    soundwave: typeof SoundWave
  }

  audioHtml: any;
  stepsModal: number = 1;
  options!: ITestimonialAudio;
  index!: number;
  captionText: string = '';
  paused: boolean = false;
  canPlay: boolean = false;
  timer!: number;
  isPlaying: boolean = false;
  unwatchClose!: Function;

  get audio()
  {
    //console.log("audio get", this.options);
    return this.options.audio;
  }

  get title()
  {
    // @ts-ignore
    return this.options.title[this.$i18n.locale];
  }

  get role()
  {
    // @ts-ignore
    return this.options.role[this.$i18n.locale];
  }

  get source()
  {
    // @ts-ignore
    return this.options.sources[this.$i18n.locale];
  }

  get subtitle(): string | null
  {
    // @ts-ignore
    if (!this.options.subtitles[this.$i18n.locale])
    {
      return null;
    }
    // @ts-ignore
    return SU.sanitizeUrl(this.options.subtitles[this.$i18n.locale].url);
  }

  get languageLabel(): string
  {
    if (this.$i18n.locale == 'fr')
    {
      return 'French';
    }

    return 'English';
  }

  get resumeTranslation(): string
  {
    return translate(this.$i18n.locale, 'general.media_resume');
  }

  get pauseTranslation(): string
  {
    return translate(this.$i18n.locale, 'general.media_pause');
  }

  get visitorThemeInfo() : string{
    // @ts-ignore
    const connnector = translate(this.$i18n.locale, 'testimonial.themeCountOf');


    const currTestimonialInfo = DataStore.currentTestimonialVisitorInfo;

    return [
      // @ts-ignore
      currTestimonialInfo.themeTitle,
      // @ts-ignore
      currTestimonialInfo.countTestimonialView,
      connnector,
      // @ts-ignore
      currTestimonialInfo.countTestimonial
    ].join(' ');

  }

  // @ts-ignore
  get isIOS():boolean
  {
    const ua = navigator.userAgent;

    if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
    {
      return true;
    }
    return false
  }

  cutSpanTitle(): void
  {
    const stringText = this.$refs.spanTitle.textContent;

    if (!stringText || stringText.length < 1)
    {
      return;
    }

    stringText.split("");
    this.$refs.spanTitle.innerHTML = "";

    let i = 0, length = stringText.length;
    for (i; i < length; i++)
    {
      this.$refs.spanTitle.innerHTML += "<span>" + stringText[i] + "</span>";
    }
  }

  playAudioFromButton ():void
  {
    this.resume();
    this.$refs.soundwave.prepareReactiveSoundWave(this.$refs.audio);
  }

  resume(): void
  {

      //console.log("before play")
      let promise = this.$refs.audio.play();

      if (promise !== undefined) //hack to avoid ios unable to autoplay
      {
        promise.then ( () =>
                {
                        this.paused = false;
                        this.canPlay = true;
                        this.isPlaying = true;
                        this.$refs.audio.volume = 0.75;




                  //console.log("now playing")
                })
               .catch ( error =>
               {
                    //console.log("something", error)

                   this.$refs.audio.setAttribute("controls", "true");
                   this.$refs.audio.classList.add("display-audio")
              })

      }


      //this.audioHtml.play();


  }


  onPlay(event:any): void
  {
    //console.log("onPlay")
    // this.canPlay = false;
    // this.$refs.audio.play();
  }

  pause(): void
  {
    this.$refs.audio.pause();
    //this.audioHtml.pause();
    this.paused = true;
  }

  startAudio(): void
  {
    //console.log("startAudio", this.$refs.audio)

    this.$refs.audio.addEventListener('ended', (event) =>
    {
      //this.audioHtml.addEventListener('ended', (event:any) => {
      if (event.target instanceof HTMLAudioElement)
      {
        this.pause();
        this.$refs.soundwave.stopDraw();
        event.target.currentTime = 0;
        this.stepsModal = 3;
      }
    });

    this.$refs.audio.addEventListener('canplay', (event) =>
    {
        //console.log("audio can play", event);
    });

    this.$refs.audio.addEventListener('abort', (event) =>
    {
      //console.log("audio abort", event);
    });

    this.$refs.audio.addEventListener('error', (event) =>
    {
      //console.log("audio error", event);
    });

    this.$refs.audio.addEventListener('loadeddata', (event) =>
    {
      //console.log("audio loadeddata", event);
    });

    this.$refs.audio.addEventListener('loadedmetadata', (event) =>
    {
      //console.log("audio loadedmetadata", event);
    });

    this.$refs.audio.addEventListener('loadstart', (event) =>
    {
      //console.log("audio loadstart", event);
    });

    this.$refs.audio.addEventListener('pause', (event) =>
    {
      //console.log("audio pause", event);
    });

    this.$refs.audio.addEventListener('play', (event) =>
    {
      //console.log("audio play", event);
    });

    this.$refs.audio.addEventListener('playing', (event) =>
    {
      //console.log("audio playing", event);
    });

    this.$refs.audio.addEventListener('stalled', (event) =>
    {
      //console.log("audio stalled", event);
    });

    this.$refs.audio.addEventListener('suspend', (event) =>
    {
      //console.log("audio suspend", event);
    });

    this.$refs.audio.addEventListener('waiting', (event) =>
    {
      //console.log("audio waiting", event);
    });

    for (let track of this.$refs.audio.textTracks)
    {
      //for (let track of this.audioHtml.textTracks) {
      track.oncuechange = (ev: Event) =>
      {
        this.captionText = '';

        if (track.mode != 'showing')
        {
          return;
        }

        const cues = track.activeCues;
        if (!cues || cues.length < 1 || track.cues == null)
        {
          return;
        }

        const cue = cues[0];

        // This is why we can't have nice things
        // @ts-ignore (text is a valid property that is not added to the ms typing base interface of TextTrackCue)
        if (cue.text == undefined)
        {
          return;
        }

        // @ts-ignore
        this.captionText = cue.text;
      };
    }
    //console.log("before resume")




    if (!this.isIOS)
    {
      this.resume();
      this.$refs.soundwave.prepareReactiveSoundWave(this.$refs.audio);

    }

    this.$refs.soundwave.prepareApp(true);



  }

  mounted(): void
  {
    this.unwatchClose = this.$watch('options.show', (value: boolean, _: boolean) =>
    {
      this.pause();
      this.$refs.soundwave.destroy();
    });

    this.cutSpanTitle();

    //console.log('MemorialVideo this.options', this.options);

    this.timer = setTimeout(() =>
                            {
                              this.stepsModal = 2;
                              this.startAudio();
                            }, 4 * 1000);
  }

  unmounted(): void
  {


    if (this.timer)
    {
      clearTimeout(this.timer);
    }

    if (this.unwatchClose)
    {
      this.unwatchClose();
    }
  }
}
